/**
 * @file    AccountDropdown.css - Styles the account dropdown component.
 *
 * @author  Alex Huctwith    <alex@kingsds.network>
 * @author  Kevin Yu    <kevin@distributive.network>
 * @date    July 2022
 */

.accountMore button:hover {
  background: #D9D9D9;
  color: var(--primary-hue-main);
  border-color: var(--primary-hue-main);
}

.accountMore > td {
  padding-bottom: 1em;
}

.accountMoreOptions {
  width: 10em;
  background-color: white;
  border-style: solid;
  border-color: var(--content-hue-main);
  border-width: 0 0 1px;
  z-index: 1;
  border-bottom: none;
  display: flex;
  flex-direction: column;
}

.accounts-table .accountMoreOptions > button {
  width: 100%;
  padding: 0.5rem 0;
  color: var(--content-hue-main);
  border-style: solid;
  border-color: #8a8a8a;
  border-width: 1px 1px 0;
  text-wrap: balance;
}

.accountMoreOptions > button:last-child {
  border-bottom: 1px solid var(--content-hue-main);
}

.accountMoreOptions > button:hover {
  border-color: var(--primary-hue-main);
  background-color: white;
  color: var(--primary-hue-main);
  
  /* Makes the next dropdown element's top border the same colour */
  &+button {
    border-top-color: var(--primary-hue-main);
  }
}

.accountMoreOptions > button:focus-visible {
  color: var(--primary-hue-main);
  border-color: var(--primary-hue-main);
  outline: none;
}

.accountMoreOptions a,
.accountMoreOptions a:visited,
.accountMoreOptions a:hover {
  color: inherit;
  text-decoration: none;
}

.optionsButton:hover,
.optionsButton:focus {
  background-color: transparent;
}

.optionsButton {
  width: 100%;
  min-height: 38px;
  min-width: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  border: transparent;
  background-color: transparent;
}

.dropdown-menu-icon {
  width: 12px;
  height: 12px;
  fill: var(--content-hue-main);
}

.dropdown-menu-icon:hover {
  fill: var(--primary-hue-main);
}

.optionsButton[data-disabled] {
  color: black;
}

.optionsButton:hover {
  cursor: pointer;
}
